import {useEffect, useState} from 'react'

/** Возвращает всегда актуальный размер видимой области, с учетом виртуальной клавиатуры на мобилке, адресной строки и всего-всего-всего. Если VisualViewport не поддерживается - фолбечится на innerWidth, innerHeight */
export const useViewportSize = () => {
  const isSupported = typeof window.visualViewport !== 'undefined'
  const [{width, height}, setVisualViewport] = useState(() =>
    isSupported
      ? {
          width: window.visualViewport.width,
          height: window.visualViewport.height,
        }
      : {width: window.innerWidth, height: window.innerHeight},
  )

  useEffect(() => {
    if (isSupported) {
      const update = () => setVisualViewport({width: window.visualViewport.width, height: window.visualViewport.height})
      window.visualViewport.addEventListener('resize', update)
      return () => window.visualViewport.removeEventListener('resize', update)
    }
  }, [isSupported])

  return {width: width, height: height}
}
